import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

import logo from "../../assets/images/logo.png";
import ioclogo from "../../assets/images/io-logo.png";

const styles = StyleSheet.create({
  page: {
    padding: 10,
    fontSize: 10,
    fontFamily: "Times-Roman",
  },
  header: {
    textAlign: "center",
    marginLeft: "0",
    marginRight: "0",
    paddingLeft: 10,
    paddingRight: 10,
  },
  headerRow: {
    border: "1pt solid black",
    display: "flex",
    flexDirection: "row",
    padding: "15px 0",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "-1px",
    marginRight: "-1px",
  },
  logo: {
    width: "40px",
    height: "40px",
    display: "inline-block",
  },
  tableRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  cell: {
    border: "1pt solid black",
    marginBottom: "-1px",
    marginRight: "-1px",
    padding: 5,
    flex: 1,
  },
  bold: {
    fontWeight: "bold",
  },
  right: {
    textAlign: "right",
  },
  
});
const getDateRange = (orders) => {
  if (!orders || Object.keys(orders).length === 0) {
    return { fromDate: null, toDate: null };
  }
  
  const dates = Object.keys(orders);
  dates.sort((a, b) => new Date(a.split('-').reverse().join('-')) - new Date(b.split('-').reverse().join('-')));
  
  return {
    fromDate: dates[0],
    toDate: dates[dates.length - 1]
  };
};


  

const LedgerReportPdf = ({ data = [] }) => {
  return (
    <Document>
      {data.map((customer, i) => {
        const entries = [];
        Object.entries(customer.orders || {}).forEach(([date, records]) => {
          records.forEach((entry) => {
            entries.push({
              date,
              description: entry.description,
              quantity: entry.quantity,
              rate: entry.rate,
              debit: entry.debit,
              credit: entry.credit,
              balance: entry.closing_balance,
            });
          });
        });
const { fromDate, toDate } = getDateRange(customer.orders);

        return (
          <Page size="A4" style={styles.page} key={i} wrap>
            {/* Header - Will repeat on each page if needed */}
            <View fixed style={styles.headerRow}>
              <Image src={ioclogo} style={styles.logo} />
              <View style={styles.header}>
                <Text style={{ fontSize: 12, fontWeight: "bold" }}>
                  &nbsp;&nbsp;&nbsp; NAMASHKAR FUEL ENERGY OPC PVT
                </Text>
                <Text>U/26, kashi Plaza, Kamrej Gam Road, Kamrej. Surat-394185</Text>
                <Text>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Mob: 9265568766 | GST No. 24AAICN3700B1Z4</Text>
              </View>
              <Image src={logo} style={styles.logo} />
            </View>

            {/* Customer & Phone */}
            <View style={[styles.tableRow, styles.section,{marginBottom:0,}]}>
              <Text style={[styles.cell, { flex: 2, minWidth:"70%",}]}>
                Customer: <Text style={styles.bold}>{customer.customer_name}</Text>
              </Text>
              <Text style={[styles.cell, { flex: 1 ,minWidth:"30%"}]}>
                Phone: {customer.phone}
              </Text>
            </View>
            <View style={[styles.tableRow, styles.section]}>
              <Text style={[styles.cell, { flex: 1, minWidth:"35%", }]}>
                From Date: {fromDate || "N/A"}
              </Text>
              <Text style={[styles.cell, { flex: 1, minWidth:"35%", }]}>
                To Date: {toDate || "N/A"}
              </Text>
              <Text style={[styles.cell, { flex: 1, minWidth:"30%" }]}>
                Opening Balance: {customer.opening_balance.toFixed(2)}
              </Text>
            </View>

            {/* Table Header - Will repeat if table spans multiple pages */}
            <View style={[styles.tableRow, { backgroundColor: '#f0f0f0' }]} fixed>
              <Text style={[styles.cell, { flex: 1 }]}>Date</Text>
              <Text style={[styles.cell, { flex: 2 }]}>Description</Text>
              <Text style={[styles.cell, { flex: 1, textAlign: "right" }]}>Qty</Text>
              <Text style={[styles.cell, { flex: 1, textAlign: "right" }]}>Rate</Text>
              <Text style={[styles.cell, { flex: 1, textAlign: "right" }]}>Debit</Text>
              <Text style={[styles.cell, { flex: 1, textAlign: "right" }]}>Credit</Text>
              <Text style={[styles.cell, { flex: 1.2, textAlign: "right" }]}>Closing Bal.</Text>
            </View>

            {/* Entries */}
            {entries.map((entry, idx) => (
              <View key={idx} style={[styles.tableRow, styles.transactionGroup]} wrap={false}>
                <Text style={[styles.cell, { flex: 1 }]}>{entry.date}</Text>
                <Text style={[styles.cell, { flex: 2 }]}>{entry.description}</Text>
                <Text style={[styles.cell, { flex: 1, textAlign: "right" }]}>
                  {entry.quantity ?? "-"}
                </Text>
                <Text style={[styles.cell, { flex: 1, textAlign: "right" }]}>
                  {entry.rate ?? "-"}
                </Text>
                <Text style={[styles.cell, { flex: 1, textAlign: "right" }]}>
                  {entry.debit ? entry.debit.toFixed(2) : "-"}
                </Text>
                <Text style={[styles.cell, { flex: 1, textAlign: "right" }]}>
                  {entry.credit ? entry.credit.toFixed(2) : "-"}
                </Text>
                <Text style={[styles.cell, { flex: 1.2, textAlign: "right" }]}>
                  {entry.balance.toFixed(2)}
                </Text>
              </View>
            ))}

            {/* Totals - Will stay together on same page */}
            <View style={[styles.totalsSection]}>
              <View style={styles.tableRow}>
                <Text style={[styles.cell, { flex: 3 }]}>Total Quantity</Text>
                <Text style={[styles.cell, { flex: 4, textAlign: "right" }]}>
                  {customer.total_qty.toFixed(2)}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.cell, { flex: 3 }]}>Total Debit</Text>
                <Text style={[styles.cell, { flex: 4, textAlign: "right" }]}>
                  {customer.total_debit.toFixed(2)}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.cell, { flex: 3 }]}>Total Credit</Text>
                <Text style={[styles.cell, { flex: 4, textAlign: "right" }]}>
                  {customer.total_credit.toFixed(2)}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.cell, { flex: 3 }]}>Closing Balance</Text>
                <Text style={[styles.cell, { flex: 4, textAlign: "right", fontWeight: "bold" }]}>
                  {customer.closing_balance.toFixed(2)}
                </Text>
              </View>
            </View>

            {/* Footer - Will appear at bottom of last page */}
            <View style={styles.footer} >
              <View style={styles.tableRow}>
                <View style={[styles.cell, { flex: 1,}]}>
                  <Text style={styles.bold}>Remarks:</Text>
                  <Text>Payment is due within 10 days of the invoice date.</Text>
                  <Text>Late payments may incur a 2% monthly interest fee.</Text>
                  <Text>Please include the invoice number in all correspondence.</Text>
                  <Text>For any queries, call +91-92655 68766.</Text>
                </View>
              </View>
              <View style={{ marginTop: 20, textAlign: "right" }}>
                <Text>From: NAMASHKAR FUEL ENERGY OPC PVT</Text>
              </View>
            </View>
          </Page>
        );
      })}
    </Document>
  );
};

export default LedgerReportPdf;